export const LIVE_REFRESH_INTERVAL = 15000;

const DEV_URL = 'https://g4yekf2946.execute-api.us-west-2.amazonaws.com/dev';
const PROD_URL = 'https://qkm1j8ip18.execute-api.us-west-2.amazonaws.com/prod';
let url = DEV_URL;

if (process.env.REACT_APP_ENV === 'prod') {
  url = PROD_URL;
}

export const API_URL = url;
